exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".TemplateInput_input__1ZME3 .TemplateInput_content__2MVpc {\n  position: relative;\n  margin-top: 16px;\n  padding: 6px 0 7px;\n  box-sizing: border-box;\n  cursor: pointer; }\n  .TemplateInput_input__1ZME3 .TemplateInput_content__2MVpc:before {\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: '\\A0';\n    position: absolute;\n    transition: border-bottom-color 200ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;\n    border-bottom: 1px solid rgba(0, 0, 0, 0.42);\n    pointer-events: none; }\n  .TemplateInput_input__1ZME3 .TemplateInput_content__2MVpc:hover:before {\n    border-bottom: 2px solid rgba(0, 0, 0, 0.87); }\n", ""]);

// exports
exports.locals = {
	"input": "TemplateInput_input__1ZME3",
	"content": "TemplateInput_content__2MVpc"
};